'use client';
import { SVGProps } from 'react';
import { m, LazyMotion, domAnimation, Variants } from 'framer-motion';

type Props = {
    variant: 'happy' | 'sad';
} & Omit<SVGProps<SVGElement>, 'ref'>;

export default function AnimatedSmiley({ variant, ...rest }: Props) {
    const eyeVariants: Variants = {
        hidden: {
            opacity: 0,
        },
        visible: (index) => ({
            opacity: 1,
            transition: {
                duration: 1,
                ease: 'easeIn',
                delay: index * 0.2,
            },
        }),
    };
    return (
        <LazyMotion features={domAnimation}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...rest}>
                <m.path
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    stroke="currentColor"
                    fill="none"
                    initial={{
                        pathLength: 0,
                        strokeWidth: 16,
                        scale: 0.8,
                        opacity: 0,
                    }}
                    animate={{
                        pathLength: 1,
                        scale: 1,
                        opacity: 1,
                    }}
                    transition={{
                        duration: 0.5,
                        ease: 'easeIn',
                    }}
                    d="M224 128 C224 181.01 181.01 224 128 224 74.98 224 32 181.01 32 128 32 74.98 74.98 32 128 32 181.01 32 224 74.98 224 128 z"
                />
                <m.path
                    fill="currentColor"
                    variants={eyeVariants}
                    initial="hidden"
                    animate="visible"
                    custom={0}
                    d="M104 108 C104 114.62 98.62 120 92 120 85.37 120 80 114.62 80 108 80 101.37 85.37 96 92 96 98.62 96 104 101.37 104 108 z"
                />
                <m.path
                    fill="currentColor"
                    variants={eyeVariants}
                    initial="hidden"
                    animate="visible"
                    custom={1}
                    d="M176 108 C176 114.62 170.62 120 164 120 157.37 120 152 114.62 152 108 152 101.37 157.37 96 164 96 170.62 96 176 101.37 176 108 z"
                />
                <m.path
                    d={
                        variant === 'happy'
                            ? 'M168,152c-8.3,14.35-22.23,24-40,24s-31.7-9.65-40-24'
                            : 'M168,176c-8.3-14.35-22.23-24-40-24s-31.7,9.65-40,24'
                    }
                    fill="none"
                    stroke="currentColor"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                    strokeWidth={16}
                    initial={{
                        pathLength: 0,
                        opacity: 0,
                    }}
                    animate={{
                        pathLength: 1,
                        opacity: 1,
                    }}
                    transition={{
                        duration: 0.5,
                        ease: 'easeIn',
                        delay: 0.25,
                    }}
                />
            </svg>
        </LazyMotion>
    );
}
